import React from 'react';
import Header from '../../Header/Header'
import Cart from '../Cart';

const CartContainer = () => {
    return (
        <div>
            <Header></Header>
            <Cart></Cart>
        </div>
    );
};

export default CartContainer;